// Global Variable
var intlTelInstance = {};

$(function() {
    if (window.location.pathname.includes('/account')) {
        initPasswordToggle();
    }
    onloadTm4u();
    tablePaginate();
    if (!document.referrer.includes('choose-from-your-nearest-advisors')) {
        checkReferral();
    }
    // if (window.location.pathname.includes('/choose-from-your-nearest-advisors')) {
    //     showMapLoading();
    // }
    initMySwiper();
    initTextColumnsFlickity();
    updateCountryState();
    enableAccountUpdateWhenFoundChanges();
    if (window.location.pathname.includes('/account') || window.location.pathname.includes('/pages/tm4u-step-2')) {
      initIntlTelInput();
    }
    // onloadInitFunctions();
    onloadGetAnchorLink();
    // setTimeout(() => {
    //     triggerMapPopup();
    //     bindFunction();
    // }, 4500);
    // setTimeout(() => {
    //     eventListnerTriggerPopup();
    // }, 4500);
    if (document.referrer.includes('register')) {
        onLoadLoader();
    }
    // initIntlTelInput();
    // advisorreportload();
    initInlineDatePicker();
    toggleMegaMenuOverlay();
    initCompanyPicturesFlickity();
})

initMySwiper = () => {
    console.log('init mySwiper');
    $('.swiper.mySwiper').each(function(index, element) {
        var _this = $(element);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = _this.data('autoplay-speed');

        var swiper_option = {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            initialSlide : 0
        }

        if (autoplay && autoplaySpeed != '') {
            swiper_option['autoplay'] = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            }
        }
        var swiper = new Swiper(this, swiper_option);
    });
}

updateSwatchFilter = (e) => {
    const _this = $(e);
    var checkbox = _this.find('input[type="checkbox"]');
    var tag = _this.parent('.tag');

    if(checkbox && tag) {
        var checkboxVal = checkbox.val();
        if (checkboxVal == 1) {
            if(checkbox.is(':checked')) {
                checkbox.val(0);
                checkbox.removeAttr('checked');
                tag.removeClass('tag--active');
            } else {
                checkbox.val(1);
                checkbox.prop('checked', true);
                tag.addClass('tag--active');
            }
        } else {
            checkbox.val(1);
            checkbox.prop('checked', true);
            tag.addClass('tag--active');
        }
    }
}



const onloadInitFunctions = () => {
    // advisorRadioButtonHandling();
    // getAdvisorLocalStorage();
    loadAdvisorName();
};

loadAdvisorName = () =>{
    if ($('#jsc-cart-advisor-name').length) {
        var advisor_name = localStorage.getItem('Advisor Name');
        if (advisor_name && advisor_name != '-') {
            $('#jsc-cart-advisor-name').text(advisor_name);
            $('#jsc-cart-advisor-name-input').val(advisor_name);
        } else {
            location.href = `/pages/${$('#advisor_page').val()}?advisor=cart`;
        }
    }
}

// Scripts for Advisor feature starts here
/**
 * HTML template for the advisor selection input field.
 * @type {string}
 */
const search_advisor_field = `
    <div class="jsc-advisor m-t-15 relative">
        <p class="m-b-5">Yes, I've had a demo before. Advisor ID/Name:</p>
        <input id="search-advisor" type="text" value="" aria-label="Yes, I've had a demo before. Advisor ID/Name" name="attributes[Advisor ID]" class="advisor-text full-width full-max-width">
        <div id="advisor-search-results" class="advisor-search-results"></div>
    </div>
`;

/**
 * Handles the changes to the demo radio buttons and updates local storage.
 */
const advisorRadioButtonHandling = () => {
    $('.demo-radio').change(function(event, data) {
        const selectedValue = $(this).val();
        localStorage.setItem('Previous Demo Experience?', selectedValue);
        if (!data || data.resetInterestedAdvisorValue === true) {
            localStorage.setItem('Would you like to select a preferred advisor?', '-');
        }
        // localStorage.setItem('Advisor ID', '');
        
        $('#jsc-advisor-error-msg').hide();
        handleAdvisorDisplay(selectedValue);
    });

    $(document).on('change', '.interested-advisor-radio', function() {
        const selectedValue = $(this).val();
        localStorage.setItem('Would you like to select a preferred advisor?', selectedValue);
        // localStorage.setItem('Advisor ID', '');
        
        $('#jsc-advisor-error-msg').hide();
        if (selectedValue === 'Yes') {
            $('.jsc-customer-input').append(search_advisor_field);
            if (localStorage.getItem('Advisor ID') && localStorage.getItem('Advisor ID') != '-') {
                $('#search-advisor').val(localStorage.getItem('Advisor ID'));
            } else {
                location.href = `/pages/${$('#advisor_page').val()}?advisor=cart`;
            }
            handleAdvisorSelector(selectedValue, 'interested-advisor-radio');
        } else if (selectedValue === 'No'){
            if (!confirm('Please confirm that you would like to proceed to checkout without selecting a preferred advisor.')) {
                // If not confirmed, revert selection
                // Find the Yes radio and check it back if it exists
                $(this).prop('checked', false);
                $("#interested-advisor-yes").prop('checked', true).trigger('change');
                localStorage.setItem('Would you like to select a preferred advisor?', 'Yes');
            } else {
                $('.jsc-advisor').remove();
                Promise.resolve(handleAdvisorSelector(selectedValue, 'interested-advisor-radio'))
                .then(() => clearAdvisorData())
                .then(() => location.reload());
            }
        }
    });
};

/**
 * Displays the advisor selection or interested advisor options based on the selected value.
 * @param {string} selectedValue - The value selected from the demo radio buttons.
 */
const handleAdvisorDisplay = (selectedValue) => {
    if (selectedValue === 'Yes') {
        $('.jsc-interested-advisor').remove();
        $('.jsc-advisor').remove();
        $('.jsc-customer-input').append(search_advisor_field);
        $('#search-advisor').val(localStorage.getItem('Advisor ID'));
        
        setTimeout(() => {
            if (localStorage.getItem('Advisor ID') == undefined || localStorage.getItem('Advisor ID') == null || localStorage.getItem('Advisor ID') == '-') {
                location.href = `/pages/${$('#advisor_page').val()}?advisor=cart`;
            }
        }, 3);

        handleAdvisorSelector(selectedValue, 'demo-radio');
    } else {
        // const refId = localStorage.getItem('Referral ID');
        // if (refId == null || refId == undefined || refId == '') {
        $('.jsc-advisor').remove();
        const noResponseHtml = `
            <div class="jsc-interested-advisor m-t-15">
                <p class="m-b-5">Would you like to select a preferred advisor? <span style="color: red;">*</span></p>
                <span>
                    <input id="interested-advisor-yes" type="radio" value="Yes" aria-label="Yes" name="attributes[Would you like to select a preferred advisor?]" class="m-r-5 interested-advisor-radio">
                    <label class="d-inline m-r-15" for="interested-advisor-yes">Yes</label>
                </span>
                <span>
                    <input id="interested-advisor-no" type="radio" value="No" aria-label="No" name="attributes[Would you like to select a preferred advisor?]" class="m-r-5 interested-advisor-radio">
                    <label class="d-inline m-r-15" for="interested-advisor-no">No</label>
                </span>
            </div>`;
        $('.jsc-customer-input').append(noResponseHtml);
        // }
    }
};

const handleAdvisorSelector = (selectedValue, radioClass) => {
    var removeAdvisor = false;
    var demoRadio = false;
    const advisorID = localStorage.getItem('Advisor ID');
    const advisorName = localStorage.getItem('Advisor Name');

    if (radioClass == 'demo-radio' && selectedValue == "Yes") {
        demoRadio = true;
        removeAdvisor = false;
        if ($('.jsc-advisor-select').hasClass('d-none')) {
            $('.jsc-advisor-select').removeClass('d-none');
        }
    }

    if (radioClass == 'interested-advisor-radio') {
        if (selectedValue === 'No') {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            removeAdvisor = true;
        } else {
            if ($('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').removeClass('d-none');
            }
            removeAdvisor = false;
        }
    }

    if (demoRadio && selectedValue == "Yes" && !removeAdvisor) {
        return CartJS.setAttributes({
            "Previous Demo Experience?": "Yes",
            // "Advisor ID": `${advisorID ? advisorID : '-'}`,
            // "Advisor Name": `${advisorName ? advisorName : '-'}`,
            "Would you like to select a preferred advisor?": "-"
        });
    } else {
        if (removeAdvisor) {
            return CartJS.setAttributes({
                // "Advisor ID": "-",
                // "Advisor Name": "-",
                "Would you like to select a preferred advisor?": "No"
            });
        } else {
            return CartJS.setAttributes({
                // "Advisor ID": `${advisorID ? advisorID : '-'}`,
                // "Advisor Name": `${advisorName ? advisorName : '-'}`,
                "Would you like to select a preferred advisor?": "Yes"
            });
        }
    }

    // $(document).on('cart.requestComplete', function(event, cart) {
    //     console.log('cart request complete');
    // })
}

// start: add advisor info at line item properties
addAdvisorInfoAtLineItemProperties = async () => {
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());

        // Filter items that are advisor products
        const advisorItems = cart.items.filter(item => item.properties && item.properties._is_advisor_product === "true");
        console.log('advisorItems: ', advisorItems);
        const updatePromises = advisorItems.map(item => {
            const updatedProps = {
                ...item.properties,
                "_Previous Demo Experience?": $('.demo-radio:checked').val() || '-',
                // "Advisor ID": localStorage.getItem('Advisor ID') || '-',
                // "Advisor Name": localStorage.getItem('Advisor Name') || '-',
                "_Would you like to select a preferred advisor?": $('.interested-advisor-radio:checked').val() || '-'
            };

            return CartJS.updateItemById(item.key, item.quantity, updatedProps);
        });
        console.log('updatePromises: ', updatePromises);

        // Wait for all updates to complete
        await Promise.all(updatePromises);
        return true;
    } catch (error) {
        console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add advisor info at line item properties

/**
 * Handles the checkout process, setting attributes and verifying advisor selections.
 * @param {Event} e - The event object from the checkout action.
 */
const checkout = async (e,is_advisor_product, is_advisor) => {
    const _this = $(e);
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    // const refId = localStorage.getItem('Referral ID');
    let isValid = true;
    let addAdvisorProperties = false;
    // const demoVal = $('.demo-radio:checked').val();
    // console.log('refId: ', refId);

    // if (is_advisor_product && is_advisor && refId) {
    //     if (demoVal === undefined) {
    //         isValid = false;
    //         $('#jsc-advisor-error-msg').show();
    //     } else {
    //         addAdvisorProperties = true;
    //         $('#jsc-advisor-error-msg').hide();
    //     }
    // } else if (is_advisor_product && is_advisor) {
    //     if (demoVal === undefined) {
    //         isValid = false;
    //         $('#jsc-advisor-error-msg').show();
    //     } else {
    //         addAdvisorProperties = true;
    //         if (demoVal === 'Yes') {
    //             const advisorIdValue = $('#search-advisor').val();
    //             localStorage.setItem('Advisor ID', advisorIdValue);
    //             $('#jsc-advisor-error-msg').hide();
    //         } else {
    //             const interestedAdvisor = $('.interested-advisor-radio:checked').val();
    //             if (interestedAdvisor === undefined) {
    //                 isValid = false;
    //                 $('#jsc-advisor-error-msg').show();
    //             } else {
    //                 if (interestedAdvisor === 'Yes') {
    //                     const advisorIdValue = $('#search-advisor').val();
    //                     localStorage.setItem('Advisor ID', advisorIdValue);
    //                     $('#jsc-advisor-error-msg').hide();
    //                 }
    //             }
    //         }
    //     }
    // }

    // check for advisor and ignore the demo and interested advisor questions
    // if (is_advisor_product && is_advisor) {
    //     if(localStorage.getItem('Advisor ID') && localStorage.getItem('Advisor ID') != '-') {
    //         addAdvisorProperties = true;
    //         $('#jsc-advisor-error-msg').hide();
    //     } else {
    //         isValid = false;
    //         $('#jsc-advisor-error-msg').show();
    //     }
    // }

    if (!$('#CartTerms').is(':checked')) {
        isValid = false;
        alert("You must agree with the terms and conditions of sales.")
    }

    if (is_advisor_product && is_advisor) {
        const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
        if (!addedAdvisorInfo) {
            isValid = false;
        }
    }

    if (isValid) {
        if (is_advisor_product && is_advisor) {
            CartJS.setAttributes({
                "_Previous Demo Experience?": $('.demo-radio:checked').val() || '-',
                // "Advisor ID": localStorage.getItem('Advisor ID') || '-',
                // "Advisor Name": localStorage.getItem('Advisor Name') || '-',
                "_Would you like to select a preferred advisor?": $('.interested-advisor-radio:checked').val() || '-'
            });
        } else {
            CartJS.setAttributes({
                "_Previous Demo Experience?": "-",
                // "Advisor ID": "-",
                // "Advisor Name": "-",
                "_Would you like to select a preferred advisor?": "-"
            });
        }
        $(document).on('cart.requestComplete', function(event, cart) {
            console.log('lplpl', event, cart);
            $loader.hide();
            $('.shopify-checkout-btn').click();
        });
    } else {
        console.log('checkout not valid, please check the checkout function condition.');
        $loader.hide();
    }
};

// start: split payment button
const splitPayment = async (is_advisor_product, is_advisor) => {
    let redirectButton = $('.shopify-checkout-btn')
    if ($('.spp2__button-container .spp2__payment-button').length > 0) {
        redirectButton = $('.spp2__button-container .spp2__payment-button');
    }
    console.log('redirectButton: ', redirectButton);

    // if (is_advisor_product && is_advisor) {
    //     let isValid = false;
        // const demoVal = $('.demo-radio:checked').val();

        // if (demoVal === undefined) {
        //     $('#jsc-advisor-error-msg').show();
        // } else {
        //     if (demoVal === 'Yes') {
        //         isValid = true;
        //     } else {
        //         const interestedAdvisor = $('.interested-advisor-radio:checked').val();

        //         if (interestedAdvisor === undefined) {
        //             $('#jsc-advisor-error-msg').show();
        //         } else {
        //             isValid = true;
        //         }
        //     }
        // }

        // start - TEMP: only check advisor id
        // if(localStorage.getItem('Advisor ID') && localStorage.getItem('Advisor ID') != '-') {
        //     $('#jsc-advisor-error-msg').hide();
        // } else {
        //     isValid = false;
        //     $('#jsc-advisor-error-msg').show();
        // }
        // end - TEMP: only check advisor id

        // if ($('#CartTerms').is(':checked')) {
        //     isValid = true
        // } else {
        //     alert("You must agree with the terms and conditions of sales.")
        //     isValid = false;
        // }

        // console.log('isValid: ', isValid);
        // if (isValid) {
        if (is_advisor_product && is_advisor) {
            await addAdvisorInfoAtLineItemProperties();
            // if (addedAdvisorInfo) {
            //     redirectButton.click();
            // }
        }
    // } else {
        console.log('spli-payment button not contain advisor product.');
        if (!$('#CartTerms').is(':checked')) {
            alert("You must agree with the terms and conditions of sales.");
        } else {
            redirectButton.click();
        }
    // }
};
// end: split payment button

/**
 * Handles the search functionality for advisors based on user input.
 * @param {Object} consultants - The list of consultants fetched from the API.
 */
const onSearchAdvisor = (consultants) => {
    $(document).on('keyup', '#search-advisor', function() {
        $('#jsc-advisor-error-msg').hide();
        const query = $(this).val().toLowerCase();
        const alphanumericRegex = /^[a-z0-9]+$/i;

        if (query !== '' && alphanumericRegex.test(query)) {
            const filteredConsultants = consultants.consultantMy.filter(consultant => {
                const consultantId = consultant["consultant'sId"].toString();
                const consultantName = consultant["consultant'sName"].toLowerCase();
                return consultantId.includes(query) || consultantName.includes(query);
            });

            $('#advisor-search-results').empty();
            if (filteredConsultants.length > 0) {
                filteredConsultants.forEach(consultant => {
                    const resultHtml = `
                        <div class="padding-10 advisor-row cursor" onclick="selectAdvisor(this, '${consultant["consultant'sId"]}')"> 
                            <span class="cursor">Consultant ID: <b>${consultant["consultant'sId"]}</b></span><br>
                            <span class="cursor">Consultant Name: <b>${consultant["consultant'sName"]}</b></span>
                        </div>`;
                    $('#advisor-search-results').append(resultHtml);
                });
            } else {
                $('#advisor-search-results').append('<div class="advisor-not-found">No matching advisor found.</div>');
            }
        } else {
            $('#advisor-search-results').empty();
        }
    });
};

/**
 * Selects an advisor from the search results and updates the input field.
 * @param {HTMLElement} e - The clicked element representing the selected advisor.
 * @param {string} id - The ID of the selected advisor.
 */
const selectAdvisor = (e, id) => {
    $('#advisor-search-results').empty();
    $('#search-advisor').val(id);
    localStorage.setItem('Advisor ID', id);
};

/**
 * Retrieves advisor-related information from local storage and updates the UI accordingly.
 */
const getAdvisorLocalStorage = () => {
    const demoValue = localStorage.getItem('Previous Demo Experience?');
    const interestedValue = localStorage.getItem('Would you like to select a preferred advisor?');
    const is_demo = demoValue ? demoValue.toLowerCase() : demoValue;
    const is_interested = interestedValue ? interestedValue.toLowerCase() : interestedValue;
    const advisor_id = localStorage.getItem('Advisor ID');
    const refId = localStorage.getItem('Referral ID');
    
    if (is_demo === "yes" || (is_demo !== 'yes' && refId !== null && refId !== undefined && refId !== '' && refId !== '-')) {
        $(`#demo-yes`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: false }]);
        if (advisor_id) {
            $('#search-advisor').val(advisor_id);
            localStorage.setItem('Advisor ID', advisor_id);
        }
        if ($('.jsc-advisor-select').hasClass('d-none')) {
            $('.jsc-advisor-select').removeClass('d-none');
        }
    } else {
        if (is_demo === 'no') {
            $(`#demo-${is_demo}`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: true }]);
        }

        if (is_interested === 'yes') {
            $(`#interested-advisor-${is_interested}`).prop('checked', true).trigger('change');
            if (advisor_id) {
                $('#search-advisor').val(advisor_id);
                localStorage.setItem('Advisor ID', advisor_id);
            }
        } else {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            $(`#interested-advisor-${is_interested}`).prop('checked', true);
        }
    }
};

// Scripts for Advisor feature ends here

// start: Product image - Gallery modal
initGalleryModal = (modal, _this, mainSliderArgs, productId, Slideshow) => {
    console.log('initGalleryModal');
    var tabs = modal.querySelectorAll('[data-tab]');
    const mainThumbnail = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);
    const mainFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);
    if (localStorage.getItem('productId') !== productId) {
        if (mainThumbnail) {
            const clonedThumbnail = mainThumbnail.cloneNode(true);
            localStorage.setItem('clonedThumbnail', clonedThumbnail.outerHTML);
        }
        if (mainFlickity) {
            const clonedFlickity = mainFlickity.cloneNode(true);
            localStorage.setItem('clonedFlickity', clonedFlickity.outerHTML);
        }
        localStorage.setItem('productId', productId);
    }

    // init gallery modal tab
    if (tabs) {
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabName = event.currentTarget.getAttribute('data-tab');

                /* start: active tab color */
                tabs.forEach(sibling => {
                    sibling.classList.remove('is-active');
                });

                tab.classList.add('is-active');
                /* end: active tab color */

                /* start: destroy flickity */
                if (_this.flickity && typeof _this.flickity.destroy === 'function') {
                    _this.flickity.destroy();
                    console.log('flickity destroy');
                }
                /* end: destroy flickity */

                /* start: clone thumbnail flickity */
                var thumbnailFlickity = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);

                if (thumbnailFlickity) {
                    clonedFlickity('clonedThumbnail', tabName, 'product__thumb-item', thumbnailFlickity, _this, mainSliderArgs);
                }
                /* end: clone thumbnail media flickity */

                /* start: clone main product media flickity */
                var galleryModalFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);

                if (galleryModalFlickity) {
                    clonedFlickity('clonedFlickity', tabName, 'product-main-slide', galleryModalFlickity, _this, mainSliderArgs, Slideshow);
                }
                /* end: clone main product media flickity */
            })
        })
    }
}
// end: Product image - Gallery modal


clonedFlickity = (name, tabName, slideClass, flickityElement, _this, mainSliderArgs, Slideshow=null) => {
    console.log('clonedFlickity: ', name);
    const storedElementHTML = localStorage.getItem(name);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = storedElementHTML;
    const retrievedElement = tempDiv.firstChild;
    retrievedElement.classList.add(name);

    const slideElement = retrievedElement.querySelectorAll(`.${slideClass}`);

    let currentThumbnailIndex = -1;
    slideElement.forEach(function(slide, index) {
        if (tabName == 'image' && slide.dataset.mediaType !== 'image') {
            slide.remove();
        } else if (tabName == 'video' && slide.dataset.mediaType !== 'video'){
            slide.remove();
        } else if (name == 'clonedThumbnail') {
            currentThumbnailIndex += 1
            slide.setAttribute('data-index', currentThumbnailIndex);
        }
    })

    flickityElement.parentNode.insertBefore(retrievedElement, flickityElement);
    flickityElement.remove();
    retrievedElement.classList.remove(name);

    if (mainSliderArgs) {
        if (name == 'clonedThumbnail') {
            mainSliderArgs.childNav = retrievedElement
        } else if (name == 'clonedFlickity' && Slideshow != null) {
            _this.flickity = new Slideshow(retrievedElement, mainSliderArgs);
            setTimeout(() => {
                _this.flickity.resize()
            }, 100)
            _this.initImageZoom();
        }
    }
}

setSliderEqualHeight = (blockId) => {
    console.log('setSliderEqualHeight - blockId: ', blockId);

    if (!blockId) {
        console.warn('setSliderEqualHeight: blockId is required');
        return;
    }

    const sectionClass = 'section--' + blockId;
    const $slider = $(`.${sectionClass}.text-columns--slider`);
    if (!$slider.length) return;

    const $slides = $slider.find('.flickity-cell');
    const $flickityViewport = $slider.find('.flickity-viewport');
    if (!$slides.length) return;

    let maxHeight = 0;

    // Reset heights
    $slides.css('height', 'auto');

    // Calculate tallest height (only if visible)
    $slides.each(function() {
        const $slide = $(this);
        if ($slide.is(':visible')) {
            const height = $slide.outerHeight();
            if (height > maxHeight) maxHeight = height;
        }
    });

    // If slider still hidden (height=0), retry after short delay
    if (maxHeight === 0) {
        setTimeout(() => setSliderEqualHeight(blockId), 50);
        return;
    }

    // Apply equal height (+5px buffer)
    $slides.css('height', `${maxHeight + 5}px`);
    $flickityViewport.css('height', `${maxHeight + 5}px`);
}

initTextColumnsFlickity = () => {
    console.log('initTextColumnsFlickity');

    $('.text-columns__flickity-slider').each(function() {
        const $slider = $(this);
        const setEqualHeight = $slider.data('set-equal-height') === true || $slider.data('set-equal-height') === 'true';
        const blockId = $slider.data('block-id') || "";
        const isAdaptiveHeight = !(setEqualHeight && blockId != "")

        console.log('isAdaptiveHeight: ', isAdaptiveHeight);
        console.log('setEqualHeight: ', setEqualHeight);
        console.log('blockId: ', blockId);

        // Initialize Flickity
        const flkty = $slider.flickity({
            cellAlign: 'left',
            freeScroll: true,
            wrapAround: true,
            adaptiveHeight: isAdaptiveHeight,
            prevNextButtons: true,
            pageDots: true,
            resize: true
        });

        setTimeout(() => {
            flkty.resize();
            if (setEqualHeight && blockId) {
                setSliderEqualHeight(blockId);
            }
        }, 100);

        // Recalculate equal heights on window resize
        if (setEqualHeight && blockId) {
            $(window).on('resize orientationchange', () => {
                setSliderEqualHeight(blockId);
            });
        }
    });
}

// Start of Storepoint customisation
// bindFunction = () =>{
//     $('.stpt-marker').attr('onclick', 'triggerMapPopup()');
//     $('.storepoint-location').attr('onclick', 'triggerMapPopup()');
//     if ($('#storepoint-container').length) {
//         var $loader = $('.jsc-loader-overlay');
//         $loader.hide();
//     }
// }

// eventListnerTriggerPopup = () =>{
//     $('body').on('click', '.storepoint-location, .stpt-marker', function() {
//         triggerMapPopup();
//     });
//     $('.mapboxgl-ctrl-geocoder--input').on('keydown', function(event) {
//         if (event.key === 'Enter') {
//             triggerMapPopup();
//         }
//     });
// }
// triggerMapPopup = () =>{
//     setTimeout(() => {
//         $('.street-address').insertBefore($('.storepoint-popup-description'));
    
//         var languages = [];
//         var _id = '';
//         var _location;
//         $('.tag-text').each(function(){
//             var _this = $(this);
//             var text = _this.text();

//             _location = _this;
            
//             if (text.includes('id_') || text.includes('Id_')) {
//                 _this.parents('span.tag').hide();
//                 _id = text.split('_')[1];
//             } else if (text.includes('food_') || text.includes('Food_')) {
//                 _this.text(text.split('_')[1]);
//             } else if (text.includes('language_') || text.includes('Language_')) {
//                 var language = text.split('_')[1];
//                 languages.push(language);
//                 _this.parents('span.tag').hide();
//             }
//         });

//         var uniqueLanguanges = Array.from(new Set(languages));
//         var html = `<div class="jsc-language text-left m-b-10 hide">`;
//         uniqueLanguanges.forEach(element => {
//             html += `<span class="uppercase m-r-5">${element}</span>`
//         });
//         html += `</div>`;
        
        
//         if (!_location.parents('.storepoint-location-popup').find('.jsc-language').length) {
//             _location.parents('.storepoint-location-popup').prepend(html);
//         }
//         if (!$(`.tag-id_${_id}`).parents('.storepoint-location').find('.jsc-language').length) {
//             $(`.tag-id_${_id}`).parents('.storepoint-location').prepend(html);
//         }
        
//         var current_name = _location.parents('.storepoint-location-popup').find('b').text();
//         var current_id = localStorage.getItem('Advisor ID');
//         var selectAdvisorBtn = `<button class="btn no-border full-width jsc-select-btn" onclick="selectMapAdvisor(this, '${_id}', '${current_name}')" ${ current_id == _id ? 'disabled' : ''}>${ current_id == _id ? 'Selected' : 'Select'}</button>`;

//         if(current_id == _id ) {
//             $('.jsc-select-btn').attr('disabled','disabled').text('Selected');
//         }
        
//         // if (!_location.parents('.storepoint-location-popup').siblings('.jsc-select-btn').length) {
//         //     $(selectAdvisorBtn).insertBefore($('.mapboxgl-popup-close-button'));
//         // }
        
//     }, 60);
// }

selectMapAdvisor = (e, id, name, profileImg) =>{
    // Use updateAdvisorData function to handle all advisor data updates
    const profilePicture = (!profileImg || profileImg === '-') ? '' : profileImg;
    updateAdvisorData(id, name, profilePicture, false);

    // Update button state
    $(e).prop('disabled', true).text('Selected');
    // console.log('ppokee', getUrlParameter('advisor'));

    // if (getUrlParameter('advisor') == 'cart') {
    //     $(document).on('cart.requestComplete', function(event, cart) {
    //         location.href = `/cart`;
    //     });
    // } else {
        // $(document).on('cart.requestComplete', function(event, cart) {
            if (id && id !== '-') {
                location.href = `/pages/storepoint-vn/id_${id}`;
            } else {
                location.href = `/`;
            }
    //     });
    // }
    
    var storepointID = window.location.href.split('selected=')[1];
console.log('storepointID 1',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);
}

getUrlParameter = (name) =>{
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// End of Storepoint customisation


// start: pdpa function
// track bank account name checkbox
$('#bank_account_name_checkbox').on('change', function() {
    if ($(this).prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
            $('#bank_account_name_checkbox_error').css('display', 'none');
        } else {
            $('#bank_account_name_checkbox_error').css('display', 'block');
        }
    } else {
        $('#bank_account_name').removeClass('jsc-disable-field');
        $('#bank_account_name_checkbox_error').css('display', 'none');
    }
});
// track address state
$('#address_state').on('change', function() {
    const selectedStateName = $(this).val();
    $(this).attr('data-default', selectedStateName);
})
// track mobile number
$('#jsc-telephone').on('focus', function() {
    $phoneInput = $('#jsc-telephone');
    let value = $phoneInput.val();

      if (value.startsWith('+60')) {
        $phoneInput.val('+60' + value.slice(3).replace(/\D/g, ''));
      } else {
        $phoneInput.val('+60');
      }
});
// track full name
$('#full_name').on('input', function() {
    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name_val = $('#full_name').val();
        $('#bank_account_name').val(full_name_val);
    }
});
// track postal code
$('#postal_code').on('input', function() {
    $postal_code = $('#postal_code');

    if ($postal_code.val().length > 5) {
        $postal_code.val($postal_code.val().slice(0, 5));
    }
});
/* intl-tel-input library: https://intl-tel-input.com/examples/validation.html */
initIntlTelInput = () => {
    const input = document.querySelector("#register_mobile");
    // initialise plugin
    intlTelInstance['iti'] = window.intlTelInput(input, {
        initialCountry: "my",
        loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
        separateDialCode: true, // Display country code separately
        nationalMode: false,    // Use full international number format
    });
    console.log('intlTelInstance: ', intlTelInstance);
}
fetchNationality = () => {
    fetch('https://cdn.shopify.com/s/files/1/0898/5218/2810/files/jsc-nationality-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(nationalities => {
            // console.log(nationalities);
            if (nationalities.length > 0) {
                $.each(nationalities, function(index, item) {
                    const listItem = $('<option></option>').text(item.Nationality).val(item.Nationality);
                    const nationalityData = $('#nationality').attr('data-default') ? $('#nationality').attr('data-default').toLowerCase() : $('#nationality').attr('data-default');
                    if (item.Nationality && item.Nationality.toLowerCase() === nationalityData) {
                        listItem.prop('selected', true);
                    }
                    $('#nationality').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
fetchMYBankList = () => {
    fetch('https://cdn.shopify.com/s/files/1/0898/5218/2810/files/jsc-my-bank-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(availableBank => {
            // console.log(availableBank);
            if (availableBank.length > 0) {
                $.each(availableBank, function(index, bank) {
                    const listItem = $('<option></option>').text(bank['Reporting Institutions']).val(bank['Reporting Institutions']);
                    const bankData = $('#bank_name').attr('data-default') ? $('#bank_name').attr('data-default').toLowerCase() : $('#bank_name').attr('data-default');
                    if (bank['Reporting Institutions'] && bank['Reporting Institutions'].toLowerCase() === bankData) {
                        listItem.prop('selected', true);
                    }
                    $('#bank_name').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
updateCountryState = () => {
    var defaultProvince = $('#address_state').attr('data-default')
    $('#address_state').val(defaultProvince);
}
enableAccountUpdateWhenFoundChanges = () =>{
    fetchNationality();
    fetchMYBankList();
    // Get the input elements
    // accept marketing input: #accepts_marketing_email, #accepts_marketing_sms, #accepts_marketing_post, #accepts_marketing_telephone,
    var accountPagePdpaInputs = $("#alias, #email, #full_name, #nric, #nationality, #register_mobile, #register_home, #postal_code, #address_state, #address_city, #address_1, #address_2, #bank_name, #bank_account_name, #bank_account_name_checkbox, #bank_account_number, #accepts_policy");

    // Get the submit button
    var updatePdpaButton = $("#update-profile");

    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
        } else {
            $('#bank_account_name_checkbox').prop('checked', false);
        }
    }

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
}
customerInfoValidation = ($email, $full_name, $nationality, $register_mobile, $register_home) => {
    var $passValidation = true;
    if ($email == '') {
        $('#email_error').show();
        $passValidation = false;
    } else {
        $('#email_error').hide();
        if ($email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
            $('#email_format_error').hide();
        } else {
            $('#email_format_error').show();
            $passValidation = false;
        }
    }

    if ($full_name == '') {
        $('#full_name_error').show();
        $passValidation = false;
    } else {
        $('#full_name_error').hide();
    }

    if ($nationality == '') {
        $('#nationality_error').show();
        $passValidation = false;
    } else {
        $('#nationality_error').hide();
    }

    console.log('$register_mobile: ', $register_mobile.trim());
    console.log('getSelectedCountryData(): ', intlTelInstance['iti'].getSelectedCountryData());
    console.log('isValidNumberPrecise: ', intlTelInstance['iti'].isValidNumberPrecise());

    if ($register_mobile.trim() == '') {
        $('#register_mobile_error').show();
        $passValidation = false;
    } else {
        $('#register_mobile_error').hide();
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#register_mobile_format_error').hide();
        } else {
            $('#register_mobile_format_error').show();
            $passValidation = false;
        }
    }

    // if ($register_home == '') {
    //     $('#register_home_error').show();
    //     $passValidation = false;
    // } else {
    //     $('#register_home_error').hide();
    // }

    return $passValidation;
}
addressValidation = ($address_1, $address_city, $address_state, $postal_code) => {
    var $passValidation = true;
    if ($address_1 == '') {
        $('#address_1_error').show();
        $passValidation = false;
    } else {
        $('#address_1_error').hide();
    }

    if ($address_city == '') {
        $('#address_city_error').show();
        $passValidation = false;
    } else {
        $('#address_city_error').hide();
    }

    if ($address_state == '') {
        $('#address_state_error').show();
        $passValidation = false;
    } else {
        $('#address_state_error').hide();
    }

    if ($postal_code == ''){
        $('#postal_code_error').show();
        $passValidation = false;
    } else {
        $('#postal_code_error').hide();
        // https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json (postal code regex)
        if ($postal_code.match(/^\d{5}$/)) {
            $('#postal_code_format_error').hide();
        } else {
            $('#postal_code_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
bankValidation = ($bank_name, $bank_account_name, $bank_account_number) => {
    var $passValidation = true;
    if ($bank_name == '') {
        $('#bank_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_name_error').hide();
    }

    if ($bank_account_name == '') {
        $('#bank_account_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_name_error').hide();
    }

    if ($bank_account_number == '') {
        $('#bank_account_number_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_number_error').hide();
        if ($bank_account_number.length >=8 && $bank_account_number.length <=17) {
            $('#bank_account_number_format_error').hide();
        } else {
            $('#bank_account_number_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
acceptsMarketingValidation = ($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone) => {
    var $passValidation = true;
    var show_accepts_marketing_error = true;
    if ($accepts_marketing_email || $accepts_marketing_sms || $accepts_marketing_post || $accepts_marketing_telephone) {
        show_accepts_marketing_error = false
    }
    if (show_accepts_marketing_error) {
        $('#accepts_marketing_error').show();
        $passValidation = false;
    } else {
        $('#accepts_marketing_error').hide();
    }

    console.log('accepts_marketing_sms: ', $accepts_marketing_sms);
    if ($accepts_marketing_sms) {
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#accepts_marketing_sms_error').hide();
        } else {
            $('#accepts_marketing_sms_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
advisorCustomerAPI = (id, em, advid, recid, recn, fn, nt, mo, ho, add, add2, city, st, pc, ctry, nob, accn, accnum, lang, spec, alias, sendEmail, mce, mcs, mct) =>{
    // accepts marketing params: mce, mcs, mcp, mct
    let $data = {
        id: id,
        advisor_id: advid,
        last_name: fn,
        address: add,
        address2: add2,
        city: city,
        state: st,
        country: ctry,
        postal_code: pc,
        email: em,
        mobile: mo,
        home: ho,
        nationality: nt,
        bank_name: nob,
        bank_account_name: accn,
        bank_account_number: accnum,
        recruiter_id: recid,
        recruiter_name: recn,
        language: lang,
        specialities: spec,
        alias: alias,
        send_email: sendEmail,
        email_marketing_consent: mce,
        sms_marketing_consent: mcs,
        tel_marketing_consent: mct
    };
    // email_marketing_consent: mce,
    // sms_marketing_consent: mcs,
    // post_marketing_consent: mcp,
    // tel_marketing_consent: mct,

    $.ajax({
        url: "https://webhooks.mechanic.dev/f99a12f7-66e3-498c-8003-1fb3c13a1c56", //user/custom/update_advisor
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
customerAPI = (id, add, add2, city, st, pc, ctry) => {
    let $data = {
        id: id,
        address: add,
        address2: add2,
        city: city,
        state: st,
        country: ctry,
        postal_code: pc
    };

    $.ajax({
        url: "https://webhooks.mechanic.dev/a6d06934-b946-4b06-a843-96d969558462", //user/custom/update
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
updatePdpaAdvisor = (evt,is_tm4u) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $full_name = $('#full_name').val();
    var $nric = $('#nric').val();
    var $nationality = $('#nationality').val();
    var $register_mobile = $('#register_mobile').val();
    var $register_home = $('#register_home').val();

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $address_city = $('#address_city').val();
    var $address_state = $('#address_state').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $bank_name = $('#bank_name').val();
    var $bank_account_name = $('#bank_account_name').val();
    var $bank_account_number = $('#bank_account_number').val();

    var $alias = $('#alias').val();
    var $advisor_language = $('#language_label').text().replace('Language', '');
    var $advisor_specialities = $('#specialities_label').text().replace('Specialities', '');

    // var $accepts_marketing_email = $('#accepts_marketing_email').prop("checked");
    // var $accepts_marketing_sms = $('#accepts_marketing_sms').prop("checked");
    // var $accepts_marketing_post = $('#accepts_marketing_post').prop("checked");
    // var $accepts_marketing_telephone = $('#accepts_marketing_telephone').prop("checked");

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $email = $('#email').val();
    var $advisor_id = $('#advisor_id').val();
    var $recruiter_id = $('#recruiter_id').val();
    var $recruiter_name = $('#recruiter_name').val();

    var $isvalidatedCustomerInfo = customerInfoValidation($email, $full_name, $nationality, $register_mobile, $register_home);
    var $isvalidatedAddress = addressValidation($address_1, $address_city, $address_state, $postal_code);
    var $isvalidatedBank = bankValidation($bank_name, $bank_account_name, $bank_account_number);
    // var $isvalidatedAcceptsMarketing = acceptsMarketingValidation($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    var $isvalidatedAdvisorLanguage = true;
    if (!is_tm4u) {
        if ($advisor_language == '') {
            $isvalidatedAdvisorLanguage = false;
            $('#language_blank_error').show();
        } else {
            $('#language_blank_error').hide();
            $('#language_error').hide();
        }
    }

    var $isvalidatedAdvisorSpecialities = true;
    if (!is_tm4u) {
        if ($advisor_specialities == '') {
            $isvalidatedAdvisorSpecialities = false;
            $('#specialities_blank_error').show();
        } else {
            $('#specialities_blank_error').hide();
            $('#specialities_error').hide();
        }
    }

    var $send_update_email = true;
    var $email_marketing_channel = '';
    var $sms_marketing_channel = '';
    var $tel_marketing_channel = '';
    var $isvalidatedAcceptsMarketing = true;

    if (is_tm4u) {
        $send_update_email = false;
        var $email_marketing_channel = $('#marketing_channel_email').prop("checked").toString().toLowerCase();
        var $sms_marketing_channel = $('#marketing_channel_sms').prop("checked").toString().toLowerCase();
        var $tel_marketing_channel = $('#marketing_channel_telephone').prop("checked").toString().toLowerCase();
        if ($sms_marketing_channel == 'false') {
            $isvalidatedAcceptsMarketing = false;
        }
    }
    if (!$isvalidatedAcceptsMarketing) {
        $('#accepts_marketing_error').show();
    } else {
        $('#accepts_marketing_error').hide();
    }

    console.log('isvalidatedCustomerInfo: ', $isvalidatedCustomerInfo);
    console.log('isvalidatedAddress: ', $isvalidatedAddress);
    console.log('isvalidatedBank: ', $isvalidatedBank);
    console.log('isvalidatedAdvisorLanguage: ', $isvalidatedAdvisorLanguage);
    console.log('isvalidatedAdvisorSpecialities: ', $isvalidatedAdvisorSpecialities);
    console.log('isvalidatedAcceptsMarketing: ', $isvalidatedAcceptsMarketing);

    if ($isvalidatedCustomerInfo && $isvalidatedAddress && $isvalidatedBank && $isvalidatedAcceptsCondition && $isvalidatedAdvisorLanguage && $isvalidatedAdvisorSpecialities && $isvalidatedAcceptsMarketing) {
        console.log('$email_marketing_channel: ', $email_marketing_channel);
        console.log('$sms_marketing_channel: ', $sms_marketing_channel);
        console.log('$tel_marketing_channel: ', $tel_marketing_channel);
        // accept marketing params: $accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone

        const intlTelCountryData = intlTelInstance['iti'].getSelectedCountryData();
        const dialCode = `+${intlTelCountryData.dialCode}`;

        if (!$register_mobile.includes(dialCode)) {
            $register_mobile = `+${intlTelCountryData.dialCode}${$register_mobile}`;
            console.log('$register_mobile added dial code: ', $register_mobile);
        }

        advisorCustomerAPI($shopifyId,
            $email, $advisor_id, $recruiter_id, $recruiter_name,
            $full_name, $nationality, $register_mobile, $register_home,
            $address_1, $address_2, $address_city, $address_state, $postal_code, $address_country_code,
            $bank_name, $bank_account_name, $bank_account_number,
            $advisor_language, $advisor_specialities, $alias, $send_update_email,
            $email_marketing_channel, $sms_marketing_channel, $tel_marketing_channel
        )
        setTimeout(() => {
            $loader.hide();
            if (is_tm4u) {
                var product_link = $(evt).attr('data-product-link');
                if (product_link) { 
                    window.location.href = product_link;
                }
            } else {
                location.reload();
            }
        }, 15000);
    } else {
        $loader.hide();
    }
}
updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $address_city = $('#address_city').val();
    var $address_state = $('#address_state').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $isvalidatedAddress = addressValidation($address_1, $address_city, $address_state, $postal_code);
    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    console.log('isvalidatedAddress: ', $isvalidatedAddress);

    if ($isvalidatedAddress && $isvalidatedAcceptsCondition) {
        customerAPI($shopifyId,
            $address_1, $address_2, $address_city, $address_state, $postal_code, $address_country_code
        )
        setTimeout(() => {
            $loader.hide();
            location.reload();
        }, 4500);
    } else {
        $loader.hide();
    }
}
openOptions = (e) => {
    const _this = $(e);
    const optionsEl = _this.siblings('.custom-options');
    _this.toggleClass('active');
    optionsEl.toggleClass('d-none');
}
// track specialities
updateSpecialities = (e) => {
    const _this = $(e);
    const specialitiesLabel = $('#specialities_label').text();
    var specialitiesArr = specialitiesLabel.split(',');
    var addSpecialities = false;

    if (_this.prop("checked")){
        addSpecialities = true;
    }

    if (addSpecialities && specialitiesLabel != 'Specialities') {
        specialitiesArr.push(_this.val());
    } else if (addSpecialities && specialitiesLabel == 'Specialities') {
        specialitiesArr.push(_this.val());
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== 'Specialities';
        });
    }

    if (addSpecialities === false) {
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (specialitiesArr.length <= 0) {
        $('#specialities_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (specialitiesArr.length > 3) {
        $('#specialities_blank_error').hide();
        $('#specialities_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#specialities_blank_error').hide();
        $('#specialities_error').hide();
        $('#specialities_label').text(specialitiesArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// track language
updateLanguage = (e) => {
    const _this = $(e);
    const langLable = $('#language_label').text();
    var langArr = langLable.split(',');
    var addLang = false;

    if (_this.prop("checked")){
        addLang = true;
    }

    if (addLang && langLable != 'Language') {
        langArr.push(_this.val());
    } else if (addLang && langLable == 'Language') {
        langArr.push(_this.val());
        langArr = langArr.filter(function(item) {
            return item !== 'Language';
        });
    }

    if (addLang === false) {
        langArr = langArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (langArr.length <= 0) {
        $('#language_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (langArr.length > 5) {
        $('#language_blank_error').hide();
        $('#language_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#language_blank_error').hide();
        $('#language_error').hide();
        $('#language_label').text(langArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// end: pdpa function
// start: Recover Password Form
showRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "true") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'false');
        $('#RecoverPasswordForm').removeClass('hide');
        $('#CustomerLoginForm').addClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'true');
    }
}
hideRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "false") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'true');
        $('#RecoverPasswordForm').addClass('hide');
        $('#CustomerLoginForm').removeClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'false');
    }
}
// end: Recover Password Form
// start: section anchor
getAnchorLink = (evt) => {
    var anchorLink = $(evt).attr('href');
    scrollToSection(anchorLink);
}
onloadGetAnchorLink = () => {
    var anchorLink = window.location.hash;
    console.log('onloadGetAnchorLink: ', onloadGetAnchorLink);
    if(anchorLink != "") {
      scrollToSection(anchorLink);
    }
}
scrollToSection = (link) => {
    var target = $('[data-anchor="' + link + '"]:first');
    if(target.length > 0) {
      window.location.hash = link;
      var top = target.offset().top - 150;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
}
// end: section anchor
// start: referral link
copyReferralLink = () => {
    // Get the text field
    var referralLink = $('#referral_link')[0];

    // Select the text field
    referralLink.select();
    referralLink.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(referralLink.value).then(function() {
        $('#copied-label').fadeIn().delay(1000).fadeOut();
    }).catch(function(error) {
        console.error("Failed to copy text: " + error);
    });;
};
// end: referral link
checkReferral = async () => {
    const $loader = $('.jsc-loader-overlay');
    console.log('Checking referral...');
    $loader.show();

    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('ref')) {
            console.log('No referral parameter found');
            return;
        }

        // Parse referral data
        const ref = urlParams.get('ref');
        const [refId, refNameEncoded] = ref.split('@');
        const refName = refNameEncoded?.replace(/_/g, ' ') || '';
        console.log('Referral ID:', refId, 'Name:', refName);

        // Get current advisor data
        const currentAdvisorId = localStorage.getItem('Advisor ID');
        const storedRefId = localStorage.getItem('Referral ID');

        // Check if this is a new referral or different from current advisor
        // const isNewReferral = refId !== storedRefId;
        // const isDifferentAdvisor = refId !== currentAdvisorId;

        // if (!isNewReferral && !isDifferentAdvisor) {
        //     console.log('Referral already set as advisor');
        //     return;
        // }

        // Validate if referral is a valid advisor and get profile picture
        const advisorValidation = await validateAdvisor(refId);

        if (advisorValidation) {
            // advisorValidation is [true, profilePicture]
            const [isValid, profilePicture] = advisorValidation;
            
            if (isValid) {
                // Update localStorage with new advisor data including profile picture
                updateAdvisorData(refId, refName, profilePicture, true);
                console.log('Advisor updated successfully with profile picture:', profilePicture);
            } else {
                // Validation returned false, clear advisor data
                clearAdvisorData();
                console.log('Referral validation failed, advisor data cleared');
            }
        } else {
            // Validation returned false, clear advisor data
            clearAdvisorData();
            console.log('Referral is not a valid advisor, advisor data cleared');
        }
    } catch (error) {
        console.error('Error in checkReferral:', error);
    } finally {
        $loader.hide();
    }
}

// Helper function to validate if an ID belongs to a valid advisor and fetch profile picture
const validateAdvisor = async (advisorId) => {
    try {
        const response = await fetch(`/pages/storepoint-vn/id_${advisorId}`);
        console.log('validate advisor for referral: ', response.status)
        if (response.status === 404) {
            return false;
        }

        const html = await response.text();

        // Create a temporary div to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const advisorIdInput = tempDiv.querySelector('input[name="advisor_id"]');
        console.log('advisorIdInput: ', advisorIdInput, 'advisorId (param): ', advisorId );

        if (!advisorIdInput) {
            return false;
        }

        const advisorIdParam = `id_${advisorId}`.toLowerCase();
        const advisorInputStr = advisorIdInput.value.trim().toLowerCase();

        if (advisorInputStr === advisorIdParam) {
            // Find the hidden input with profile picture
            const profilePictureInput = tempDiv.querySelector('input[name="advisor_profile_picture"]');
            let profilePicture = '';
            if (profilePictureInput && profilePictureInput.value) {
                profilePicture = profilePictureInput.value;
            }
            return [true, profilePicture]
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error validating advisor:', error);
        return false;
    }
}

// Helper function to update advisor data in localStorage, cart attributes and UI
const updateAdvisorData = (advisorId, advisorName, advisorProfilePicture = '', isReferral = false) => {
    // Update localStorage
    localStorage.setItem('Advisor ID', advisorId);
    localStorage.setItem('Advisor Name', advisorName);
    localStorage.setItem('Advisor Profile Picture', advisorProfilePicture);
    var storepointID = window.location.href.split('selected=')[1];
    // console.log('storepointID 2',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);

    // Only update referral localStorage if isReferral is true
    if (isReferral) {
        localStorage.setItem('Referral ID', advisorId);
        localStorage.setItem('Referral Name', advisorName);
    }

    // Update cart attributes
    // CartJS.setAttributes({
    //     'Advisor ID': advisorId,
    //     'Advisor Name': advisorName
    //     // 'Advisor Profile Picture': advisorProfilePicture
    // });

    // Update UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text(advisorName);
    }

    // Dispatch advisor:selected event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:selected', {
        detail: {
            id: advisorId,
            name: advisorName,
            profileImg: advisorProfilePicture
        }
    }));
}

// Helper function to clear advisor data from localStorage, cart attributes and UI
const clearAdvisorData = () => {
    // Clear localStorage
    localStorage.removeItem('Advisor ID');
    localStorage.removeItem('Advisor Name');
    localStorage.removeItem('Advisor Profile Picture');
    localStorage.removeItem('Referral ID');
    localStorage.removeItem('Referral Name');
    localStorage.removeItem('Advisor Storepoint ID');

    // Clear cart attributes
    // CartJS.setAttributes({
    //     'Advisor ID': '',
    //     'Advisor Name': ''
    //     // 'Advisor Profile Picture': '-'
    // });

    // Clear UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text('');
    }

    // Clear advisor name input if exists
    const $advisorNameInput = $('#jsc-cart-advisor-name-input');
    if ($advisorNameInput.length) {
        $advisorNameInput.val('');
    }

    // Clear search advisor input if exists
    const $searchAdvisorInput = $('#search-advisor');
    if ($searchAdvisorInput.length) {
        $searchAdvisorInput.val('');
    }

    // Dispatch advisor:cleared event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:cleared'));
}

hideCustomerCartInput = () => {
    const refId = localStorage.getItem('Referral ID');
    const refName = localStorage.getItem('Referral Name');
    if (refId && refName) {
        if (!$('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').addClass('d-none');
        }
        localStorage.setItem('Previous Demo Experience?', '-');
        localStorage.setItem('Would you like to select a preferred advisor?', '-');
    } else {
        if ($('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').removeClass('d-none');
        }
    }
}

// start: tm4u
onloadTm4u = () => {
    assignTm4uLocalStorage();
    redirectTm4uStep2Page();
    resetDuplicatedTag();
} 
getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
assignTm4uLocalStorage = () => {
    const tm4uValue = getQueryParam("tm4u");
    if (tm4uValue === "true") {
        localStorage.setItem("tm4u", tm4uValue);
    }

    const comingFrom = getQueryParam("from");
    if (comingFrom === "newcomer-step-2" || comingFrom == "newcomer-owned") {
        localStorage.setItem("tm4u-redirect-link", comingFrom);
    }
}
redirectTm4uStep2Page = () =>{ 
    setTimeout(() => {
        if (window.location.pathname == '/pages/advisor-page' || window.location.pathname == '/account' || window.location.pathname == '/') {
            if (localStorage.getItem("tm4u") === "true" && localStorage.getItem("tm4u-redirect-link") != "") {
                localStorage.removeItem("tm4u");
                window.location.href = `/pages/${localStorage.getItem("tm4u-redirect-link")}`;
            }
        }
    }, 900);
}

showConfirmation = () =>{
    let nric = $('#tm4u_nric_verify').val();

    if (nric.length == 12) {
        $('#confirm-nric').text(nric);
        $('#jsc-tm4u-overlay').css('display', 'block');
        $('#jsc-tm4u-popup').show();
    } else {
        $('#nric-digit-error').show();
    }
}
closeConfirmation = () =>{
    $('#jsc-tm4u-overlay').css('display', 'none');
    $('#jsc-tm4u-popup').hide();
}
verifyNRIC = (e,id) =>{
    const $loader = $('.jsc-loader-overlay');
    let mechanic_webhook = 'https://webhooks.mechanic.dev/72cb947a-eca1-4c04-9477-144127244ef5';
    let nric = $('#tm4u_nric_verify').val();
    let this_customer_id = `gid://shopify/Customer/${id}`;
    let $data = {
        nric: nric,
        gid: this_customer_id
    };
    
    $.ajax({
        url: mechanic_webhook, //user/verify/nric
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data),
        success: function(response) {
            console.log("Success:", response);
            // $loader.append(`<p class="verify-load">Hang tight! We're verifying your details—this might take a moment. No need to refresh, we've got this! 🚀</p>`);
            $loader.show();
            setTimeout(() => {
                location.reload();
            }, 6000);
        },
        error: function(xhr, status, error) {
            console.error("Error:", xhr.responseText);
            // alert("An error occurred: " + xhr.responseText);
        }
    });
}
limitInput = (input, maxLength) => {
    if (input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
    }
}
resetDuplicatedTag = () =>{
    let reset_duplicate_tag = $('#reset_duplicated_tag');
    if (reset_duplicate_tag.length) {
        let id = reset_duplicate_tag.val();
        let mechanic_webhook = 'https://webhooks.mechanic.dev/12744d05-1a49-4747-993a-aeba4a3e601f';
        let this_customer_id = `gid://shopify/Customer/${id}`;
        let $data = {
            gid: this_customer_id,
        };
        
        $.ajax({
            url: mechanic_webhook, //user/verify/reset
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            data: JSON.stringify($data)
        });
    }
}
submitstep2b = (e) =>{
    // click upload NRIC
    $('.cf-submit-form').click();
    
    setTimeout(() => {
        if ($('.cf-step-invalid').length) {
            $('html, body').animate({
                scrollTop: $('.cf-step-invalid').first().offset().top - 120
            }, 500);            
        } else {
            if ($('.jsc-accepts_policy').length === $('.jsc-accepts_policy:checked').length) {
                $('#accepts_policy_error').hide();
                updatePdpaAdvisor(e,true);
                $('html, body').animate({
                    scrollTop: $('.step2b').first().offset().top - 120
                }, 500);
            } else {
                $('#accepts_policy_error').show();
            }
        }
    }, 1200);
}
// end: tm4u
// start: register form
submitRegisterForm = (e) =>{
    console.log('submitRegisterForm...')
    const password = $('#CreatePassword').val();
    const phone = $('#jsc-telephone').val();
    const address1 = $('#jsc-address1').val();
    const address2 = $('#jsc-address2').val();
    const state = $('#jsc-state').attr('data-default');
    const city = $('#jsc-city').val();
    const postalCode = $('#jsc-postal-code').val();
    const $loader = $('.jsc-loader-overlay');
    var passRegister = true;

    $loader.show();
    console.log('jsc-telephone: ', phone);
    // Check if password length is less than 12
    if (password.length < 12) {
        $('#password-error').show(); // Show error message
        passRegister = false;
    } else {
        $('#password-error').hide(); // Hide error message
    }

    // Check if the phone follow Sinagpore mobile fomat
    if (phone != '' || phone != '+60') {
        $('#phone-blank-error').hide();
        if (phone.match(/^\+60(1[0-9]{8,9})$/)) {
            $('#phone-format-error').hide(); // Show error message
        } else {
            $('#phone-format-error').show(); // Hide error message
            passRegister = false;
        }
    } else {
        $('#phone-blank-error').show();
        passRegister = false;
    }

    // Check address 1
    if (address1 == '') {
        $('#address1-blank-error').show();
        passRegister = false;
    } else {
        $('#address1-blank-error').hide();
    }

    // Check city
    if (city == '') {
        $('#city-blank-error').show();
        passRegister = false;
    } else {
        $('#city-blank-error').hide();
    }

    // Check state
    if (state == '') {
        $('#state-blank-error').show();
        passRegister = false;
    } else {
        $('#state-blank-error').hide();
    }

    // Check postal code format
    if (postalCode == ''){
        $('#zip-blank-error').show();
        passRegister = false;
    } else {
        $('#zip-blank-error').hide();
        if (postalCode.match(/^\d{5}$/)) {
            $('#zip-format-error').hide();
        } else {
            $('#zip-format-error').show();
            passRegister = false;
        }
    }

    console.log('passRegister: ', passRegister);
    if(passRegister) {
        $('#register-form-error').hide();
        const formated_address1 = address1.replace(/,/g, '%&%');
        const formated_address2 = address2.replace(/,/g, '%&%');
        const formated_city = city.replace(/,/g, '%&%');
        const customer_tag = `__tel:${phone},__address1:${formated_address1},__address2:${formated_address2},__city:${formated_city},__province:${state},__zip:${postalCode}`;
        $('#jsc-customer-tag').val(customer_tag);
        // console.log('customer_tag: ', customer_tag);
        setTimeout(() => {
            $('#register-submit').click();
        }, 5000);
    } else {
        $('#register-form-error').show();
        $loader.hide();
    }
}
// end: register form

//start:Pagination
tablePaginate = () =>{
    if($('#jsc-advisor-report').length > 0) {
        console.log('He');
        
        let table = new DataTable('#jsc-advisor-report', {
            responsive: true,
            paging: false,
            pageLength: 20
        });
    }
}
//end:Pagination
// start: map loading modal
showMapLoading = () => {
    console.log('showMapLoading...');
    $('#map-loading-modal').fadeIn();
    $('body').addClass('disabled-event');

    // Set a timeout to hide the modal after 5 seconds (5000 ms)
    setTimeout(function() {
        $('#map-loading-modal').fadeOut();
        $('body').removeClass('disabled-event');
    }, 5000);
}
//end: map loading modal
// start: onload loader
onLoadLoader = () => {
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    $(window).on('load', function() {
        setTimeout(function() {
            $loader.hide();
        }, 2000);
    });
}
// end: onload loader

//start:Pagination
tablePaginate = () =>{
    console.log('ssss', $('#jsc-advisor-report'));
    
    if($('#jsc-advisor-report').length > 0) {
        console.log('He');
        
        // let table = new DataTable('#jsc-advisor-report', {
        //     responsive: true,
        //     paging: false,
        //     pageLength: 20
        // });
    }
}
//end:Pagination
advisorreportload = () => {
    if($('#jsc-advisor-report').length > 0) {
        $('.jsc-loader-overlay').show();
        var advisor_id = parseInt($('#advisor_id_load').val());
        $.ajax({
            url: 'https://jumpstartcommerce.retool.com/url/run-main-my-report',
            method: 'POST', // Change to GET, PUT, DELETE as needed
            headers: {
            },
            contentType: 'application/json',
            data: JSON.stringify({
            advisor_id: advisor_id // Example payload, adjust as needed
            }),
            success: function (data) {
            console.log('webhooks done',data.data_report);
            $('#jsc-advisor-report tbody').append(data.data_report);
            DataTable.datetime('DD/MM/YYYY');
            $('#jsc-advisor-report').DataTable({
                pageLength: 20,
                order: [
                    [0, 'desc']
                ],
                lengthChange: false,
                columnDefs: [
                    { targets: '_all', width: 'auto' }
                ],
                scrollX: true,
                searching: false
            });

            if (window.innerWidth < 480) {
                const colWidth = $('.datepicker-range').width() + 'px';
                document.documentElement.style.setProperty('--col-width-datepicker-range', colWidth);
            }
                
            $('.row-advisor-data').append(data.data_report);
            saveOrderTableRows();
            getFilteredOrder();
            $('#jsc-advisor-report').show();
            $('.jsc-loader-overlay').hide();
            },
            error: function (xhr, status, error) {
            console.error('Error fetching data:', error);
            $('.jsc-loader-overlay').hide();
            }
        });
    }
}

// Function to save order table rows to localStorage
saveOrderTableRows = () => {
    const orderTableRows = $('.row-advisor-data tr').map(function() {
        return $(this).prop('outerHTML');
    }).get();
    
    localStorage.setItem('orderTableRows', JSON.stringify(orderTableRows));
    console.log('Order table rows saved to localStorage');
}
let filteredOrderTable;
getFilteredOrder = (searchText = '') => {
    const params = new URLSearchParams(window.location.search);
    const startDateParam = params.get('startDate');
    const endDateParam = params.get('endDate');
    const $loader = $('.jsc-loader-overlay');
    let filterByDate = false;

    $loader.show();

    searchText = searchText || $('#jsc-advisor-search').val() || ""
    console.log('searchText: ', searchText)

    if (!startDateParam || !endDateParam) {
        localStorage.removeItem('orderStartDate');
        localStorage.removeItem('orderEndDate');
    } else {
        filterByDate = true
    }

    console.log('startDateParam: ', startDateParam);
    console.log('endDateParam: ', endDateParam);

    const storedRows = localStorage.getItem('orderTableRows');
    if (!storedRows) {
        $loader.hide();
        return;
    }

    try {
        const orderTableRows = JSON.parse(storedRows);
        let startDate = new Date();
        let endDate = new Date();
        console.log('orderTableRows count:', orderTableRows.length);

        if (filterByDate) {
            // Parse dates once
            startDate = new Date(startDateParam);
            endDate = new Date(endDateParam);
            endDate.setHours(23, 59, 59, 999); // Set end date to end of day
        }

        // Filter rows based on date range
        const filteredRows = orderTableRows.filter(row => {
            // Extract date from the row
            let rowMatchCondition = false;
            if (searchText !== '') {
                rowMatchCondition = row.match(/data-label="([^"]+)">([^<]+)<\/td>/g)
                .some(cell => {
                    const cellMatch = cell.match(/data-label="([^"]+)">([^<]+)<\/td>/);
                    return cellMatch && cellMatch[2].toLowerCase().includes(searchText.toLowerCase());
                });
            }

            let dateMatchCondition = false;
            if (filterByDate) {
                const dateMatch = row.match(/data-label="Date">([^<]+)<\/td>/);

                // Check if the row contains the date and if it is within the desired range
                if (dateMatch && dateMatch[1]) {
                    const rowDate = new Date(dateMatch[1].split('/').reverse().join('-'));
                    dateMatchCondition = rowDate >= startDate && rowDate <= endDate;
                }
            }

            if (!filterByDate && searchText === "") {
                rowMatchCondition = true
            }
            // Return true if either the date matches or the row match condition is true
            return dateMatchCondition || rowMatchCondition;
        });

        console.log('filteredRows count:', filteredRows.length);

        // Create table HTML structure
        const tableHeader = '<table id="jsc-advisor-report-filter-range" class="table--responsive table--small-text">' +
            '<thead><tr>' +
            '<th>Order Number</th>' +
            '<th>Date</th>' +
            '<th>Return Order ID</th>' +
            '<th>Advisor ID</th>' +
            '<th>Advisor Name</th>' +
            '<th>Team Leader ID</th>' +
            '<th>Team Leader</th>' +
            '<th>Branch Manager ID</th>' +
            '<th>Branch Manager</th>' +
            '<th>Product Description</th>' +
            '<th>Order Quantity</th>' +
            '</tr></thead><tbody>';

        const tableFooter = '</tbody></table>';

        // '<th>Customer Name</th>' +
        // '<th>Customer Email</th>' +
        // '<th>Customer Phone Number</th>' +

        // Join filtered rows and create complete table HTML
        const tableRowHtml = filteredRows.length > 0
            ? tableHeader + filteredRows.join('') + tableFooter
            : tableHeader + '<td colspan="11" class="dt-empty">No matching records found</td>' + tableFooter

        // Update UI
        if (filteredOrderTable) {
            filteredOrderTable.destroy();
        }

        // Update the filtered table content
        $('.row-advisor-data-filter').empty().append(tableRowHtml);
        $('.row-advisor-data-filter').removeClass('hide');

        // Initialize DataTable if there are rows
        if (filteredRows.length > 0) {
            $('#jsc-advisor-report-filter-range').DataTable({
                pageLength: 20,
                order: [
                    [0, 'desc']
                ],
                lengthChange: false,
                columnDefs: [
                    { targets: '_all', width: 'auto' }
                ],
                scrollX: true,
                searching: false
            });
        }

        // Update UI elements
        $('#jsc-advisor-report-filter').css('display', 'block');
        $('#table-account').css('display', 'none');
        $('.unfilterpagination').css('display', 'none');
        if (filterByDate) {
            $('#calendar-container').find('.date-range-clear-button').removeClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label').text(`${startDateParam} - ${endDateParam}`);
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label-img').addClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').attr('data-open', false);
        }
        $('#jsc-advisor-report_wrapper').hide();
    } catch (error) {
        console.error('Error processing filtered orders:', error);
    } finally {
        $loader.hide();
    }
}
formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}
$('.date-range-apply-button').on('click', (e) => {
    var _this = $(e.currentTarget);
    var startDateText = _this.parent().siblings().find('#acc-order-start-date-text').text();
    var endDateText = _this.parent().siblings().find('#acc-order-end-date-text').text();
    var $loader = $('.jsc-loader-overlay');
    var tableRowHtml = ''

    $loader.show();
    if (startDateText != 'yyyy-mm-dd' && endDateText != 'yyyy-mm-dd') {
        const startDate = new Date(startDateText);
        const endDate = new Date(endDateText);
        if (startDate <= endDate) {
            let currentUrl = new URL(window.location.href);
            let params = currentUrl.searchParams;
            let pageNumber = params.get('page');

            if (pageNumber) {
                params.delete('page');
            }

            params.set('startDate', startDateText);
            params.set('endDate', endDateText);

            window.history.replaceState({}, '', `${currentUrl.pathname}?${params.toString()}`);
            getFilteredOrder();
        } else {
            alert('Please ensure that the start date of the filter is earlier than the end date.')
        }
    }
    $loader.hide();
});
$('#jsc-advisor-search').on('keyup', function() {
    let inputValue = $(this).val();
    getFilteredOrder(inputValue);
});
$('#toggle-calendar').on('click', (e) => {
    console.log('qwqeqwe');
    
    var _this = $(e.currentTarget);
    let params = new URLSearchParams(window.location.search);
    let startDateParam = params.get('startDate');
    let endDateParam = params.get('endDate');

    if(startDateParam) {
        $('#acc-order-start-date-text').text(startDateParam);
    } else {
        $('#acc-order-start-date-text').text('yyyy-mm-dd');
    }
    if(endDateParam) {
        $('#acc-order-end-date-text').text(endDateParam);
    } else {
        $('#acc-order-end-date-text').text('yyyy-mm-dd');
    }

    var open = _this.attr('data-open') === 'true';
    _this.attr('data-open', !open);
});
initInlineDatePicker = () => {
    console.log('initInlineDatePicker');
    const today = new Date();
    const maxDate = $.datepicker.formatDate('mm/dd/yy', today);

    $("#acc-order-start-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-start-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderStartDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });
    $("#acc-order-end-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-end-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderEndDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });

    const startDate = localStorage.getItem('orderStartDate');
    const endDate = localStorage.getItem('orderEndDate');
    if (startDate) {
        $("#acc-order-start-date").datepicker("setDate", startDate);
        var [month, day, year] = startDate.split('/')
        $('#acc-order-start-date-text').text(`${year}-${month}-${day}`);
    }
    if (endDate) {
        $("#acc-order-end-date").datepicker("setDate", endDate);
        var [month, day, year] = endDate.split('/')
        $('#acc-order-end-date-text').text(`${year}-${month}-${day}`);
    }
}
$('.date-range-clear-button').on('click', (e) => {
    localStorage.removeItem('orderStartDate');
    localStorage.removeItem('orderEndDate');
    
    // Clear URL parameters without refreshing the page
    let currentUrl = new URL(window.location.href);
    let params = currentUrl.searchParams;
    
    // Remove startDate and endDate parameters
    params.delete('startDate');
    params.delete('endDate');
    
    // Update the URL without refreshing the page
    window.history.replaceState({}, '', `${currentUrl.pathname}${params.toString() ? '?' + params.toString() : ''}`);
    
    // Reset the date picker text fields
    $('#acc-order-start-date-text').text('yyyy-mm-dd');
    $('#acc-order-end-date-text').text('yyyy-mm-dd');
    
    // Hide the clear button
    $('#calendar-container').find('.date-range-clear-button').addClass('d-none-important');
    
    // Reset the toggle calendar label
    $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label').text('Select Date Range');
    $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label-img').removeClass('d-none-important');

    $('.row-advisor-data-filter').empty();
    $('.row-advisor-data-filter').addClass('hide');
    $('#jsc-advisor-report_wrapper').show();
    getFilteredOrder();
});
// start: faq collapsible
showMoreCollapsible = (e) => {
    const _this = $(e);
    const _container = $(e).parent();
    const _showLessBtn = _this.siblings('.collapsible-show-less');
    const _siblings = _this.siblings('.jsc-faq-collapsible.d-none');
    console.log('_siblings: ', _siblings)
    if (_siblings.length > 0){
        $.each(_siblings, function(index, element) {
            $(element).removeClass('d-none');
        });
        _this.css('display', 'none');
        _showLessBtn.css('display', 'block');
        _showLessBtn.insertAfter(_container.find('.jsc-faq-collapsible').last());
    }
}
showLessCollapsible = (e) => {
    const _this = $(e);
    const _showMoreBtn = _this.siblings('.collapsible-show-more');
    const _siblings = _this.siblings('.jsc-faq-collapsible');
    $.each(_siblings, function(index, element) {
        $(element).addClass('d-none');
    });
    _this.css('display', 'none');
    _showMoreBtn.css('display', 'block');
}
// end: faq collapsible
// start: download pdf (print)
triggerDownloadPdf = (e, contentId) => {
    const _this = $(e);
    let $content = $('#' + contentId);
    let divContents = $content.length ? $content.html() : '';

    if (divContents !== '') {
        let styleSheet1 = _this?.attr('data-css1') || '';
        let styleSheet2 = _this?.attr('data-css2') || '';
        let printWindow = window.open('', '', 'height=800,width=800');

        let htmlContent = '<html><head><title>Print E-Business Card</title>';
        if (styleSheet1 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet1}" preload>`;
        }
        if (styleSheet2 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet2}" preload>`;
        }
        htmlContent += `</head><body><div class="page-width page-content">${divContents}</div></body></html>`;

        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        setTimeout(function () {
            printWindow.print();
        }, 1000);
    }
}
// end: download pdf (print)
// start: implement overlay when menu dropdown is open
function toggleMegaMenuOverlay() {
    const detailsList = document.querySelectorAll('.site-nav__details');
    const headerElements = document.querySelectorAll('.site-header__element');
    const mainContent = document.querySelector('.main-content');

    if (detailsList.length === 0 || headerElements.length === 0 || !mainContent) return;

    // Check if ANY dropdown is open
    const isAnyOpen = Array.from(detailsList).some(details => details.hasAttribute('open'));

    if (isAnyOpen) {
      // Full-page blur overlay inside .main-content
      if (!document.querySelector('.jsc-blurred-overlay')) {
        const overlay = document.createElement('div');
        overlay.classList.add('jsc-blurred-overlay');
        mainContent.appendChild(overlay);
      }

      // Light overlays only for first 2 header elements
      headerElements.forEach((headerElement, index) => {
        if (index < 2 && !headerElement.querySelector('.jsc-light-overlay')) {
          const lightOverlay = document.createElement('div');
          lightOverlay.classList.add('jsc-light-overlay');
        //   headerElement.style.position = 'relative';
          headerElement.appendChild(lightOverlay);
        }
      });
  
      document.addEventListener('click', handleOutsideClick);
    } else {
      removeMegaMenuOverlay();
    }
}
  
function removeMegaMenuOverlay() {
    document.querySelector('.jsc-blurred-overlay')?.remove();
    document.querySelectorAll('.jsc-light-overlay').forEach(el => el.remove());

    // Close ALL open details
    document.querySelectorAll('.site-nav__details[open]').forEach(details => {
        details.removeAttribute('open');
    });

    document.removeEventListener('click', handleOutsideClick);
}
  
function handleOutsideClick(event) {
    const detailsList = document.querySelectorAll('.site-nav__details');
    if ([...detailsList].every(details => !details.contains(event.target))) {
    removeMegaMenuOverlay();
    }
}

// --- New close button logic ---
const closeIcons = document.querySelectorAll('.jsc-close-icon');
if (closeIcons.length > 0) {
  closeIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      removeMegaMenuOverlay();
    });
  });
}

// Observe ALL details elements
const targets = document.querySelectorAll('.site-nav__details');
targets.forEach(target => {
    const observer = new MutationObserver(toggleMegaMenuOverlay);
    observer.observe(target, { attributes: true, attributeFilter: ['open'] });
});
// end: implement overlay when menu dropdown is open

// start: check warranty period
const fetchWarrantyPeriod = async (serialNumber) => {
  try {
      const response = await fetch('https://jumpstartcommerce.retool.com/url/check-warranty-period-vn', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              serialNo: serialNumber
          })
      });

      if (!response.ok) {
          console.error(`HTTP error! status: ${response.status}`);
          return {
              status: 'error'
          };
      }

      const data = await response.json();
      return data;
  } catch (error) {
      console.error('Error fetching warranty period:', error);
      return {
          status: 'error'
      };
  }
  // return {
  //     "status": "success",
  //     "warrantyInfo": {
  //         "expiredDate": "2025-10-03",
  //         "productDescription": "Test Product"
  //     }
  // }
}

// Global function to check warranty activation from form
// Note: For onclick with hyphenated name, use: onclick="window['warranty-activation-checker']()"
// Or use camelCase: onclick="warrantyActivationChecker()"
async function warrantyActivationChecker() {
  const $loader = $('.jsc-loader-overlay');
  
  try {
    // Show loading spinner
    $loader.show();
    
    // Get the serial number from the input field
    const serialNumberInput = document.querySelector('input[name="serial_number"]') || document.querySelector('#766105');
    
    if (!serialNumberInput) {
      console.error('Serial number input field not found');
      $loader.hide();
      alert('Serial number input field not found');
      // Trigger submit button if no serial number field found
      $('.cf-submit-form').click();
      return;
    }
    
    const serialNumber = serialNumberInput.value.trim();
    
    if (!serialNumber) {
      console.error('Serial number is empty');
      $loader.hide();
      // Trigger submit button if serial number is empty
      $('.cf-submit-form').click();
      return;
    }
    
    // Call fetchWarrantyPeriod with the serial number
    const result = await fetchWarrantyPeriod(serialNumber);
    
    // Handle the result (you can customize this based on your needs)
    console.log('Warranty check result:', result);
    console.log('Serial Number:', serialNumber);
    
    // If result status is success, it means serial number has already been used
    if (result && result.status === 'success') {
      $loader.hide();
      alert('Số sê-ri này đã được sử dụng. (This serial number has been used.)');
      return;
    }
    
    // If result status is fail or error, trigger submit button
    if (!result || result.status === 'error' || result.status === 'fail') {
      $('.cf-submit-form').click();
      return;
    }
    
    // Hide loader if successful
    $loader.hide();
    
    return result;
  } catch (error) {
    console.error('Error in warranty activation checker:', error);
    $loader.hide();
    // Trigger submit button on error
    $('.cf-submit-form').click();
  } finally {
    // Ensure loader is hidden even if something goes wrong
    $loader.hide();
  }
}

// Make it accessible globally
window.warrantyActivationChecker = warrantyActivationChecker;
// Also accessible with hyphenated name (use bracket notation in onclick)
window['warranty-activation-checker'] = warrantyActivationChecker;
 /**
   * Fetches the warranty-result page and replaces the #warranty-result content
   * @param {string} warrantyResultContentHtml - HTML content to inject into #warranty-result
   * @returns {Promise<void>}
*/
// const fetchAndDisplayWarrantyResult = async (warrantyResultContentHtml) => {
//     try {
//       const response = await fetch(`/pages/warranty-result`);

//       if (!response.ok) {
//         console.log('Failed to fetch warranty result page');
//         return;
//       }

//       const html = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');

//       // Extract MainContent element
//       const mainContent = doc.querySelector('#MainContent');

//       if (mainContent) {
//         console.log('MainContent found, extracting warranty-result element...');

//         // Find warranty-result element within MainContent
//         const warrantyResultElement = mainContent.querySelector('#warranty-result');

//         if (warrantyResultElement && warrantyResultContentHtml) {
//           console.log('Replacing warranty-result content with actual data');
//           // Replace the warranty-result content with the actual warranty result
//           warrantyResultElement.innerHTML = warrantyResultContentHtml;

//           return mainContent;
//         } else {
//           console.log('warranty-result element not found or no content to replace');
//           return;
//         }
//       } else {
//         console.log('MainContent element not found in response');
//         return;
//       }
//     } catch (fetchError) {
//         console.log('Error fetching warranty result page:', fetchError);
//         return;
//     }
// };

const checkWarrantyPeriod = async (e) => {
    const warrantyIcons = {
        'failed': '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="20" fill="#BD0016"/><path d="M12.5 28L27.4298 13" stroke="white" stroke-width="5"/><path d="M12.5 13L27.5 27.9298" stroke="white" stroke-width="5"/></svg>',
        'infoGrey': '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="20" fill="#3B4041"/><path d="M17.3886 31V14.6364H22.5981V31H17.3886ZM19.9987 12.7294C19.2671 12.7294 18.6386 12.4879 18.113 12.005C17.5874 11.5149 17.3247 10.9254 17.3247 10.2365C17.3247 9.55469 17.5874 8.9723 18.113 8.48935C18.6386 7.99929 19.2671 7.75426 19.9987 7.75426C20.7373 7.75426 21.3659 7.99929 21.8843 8.48935C22.4099 8.9723 22.6727 9.55469 22.6727 10.2365C22.6727 10.9254 22.4099 11.5149 21.8843 12.005C21.3659 12.4879 20.7373 12.7294 19.9987 12.7294Z" fill="white"/></svg>',
        'infoGreen': '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="20" fill="#009D29"/><path d="M17.3886 31V14.6364H22.5981V31H17.3886ZM19.9987 12.7294C19.2671 12.7294 18.6386 12.4879 18.113 12.005C17.5874 11.5149 17.3247 10.9254 17.3247 10.2365C17.3247 9.55469 17.5874 8.9723 18.113 8.48935C18.6386 7.99929 19.2671 7.75426 19.9987 7.75426C20.7373 7.75426 21.3659 7.99929 21.8843 8.48935C22.4099 8.9723 22.6727 9.55469 22.6727 10.2365C22.6727 10.9254 22.4099 11.5149 21.8843 12.005C21.3659 12.4879 20.7373 12.7294 19.9987 12.7294Z" fill="white"/></svg>',
        'checkmark': '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="20" fill="#009D29"/><path d="M8.5 19.3919L16.5702 27.5L31.5 12.5" stroke="white" stroke-width="5"/></svg>'
    }
  e.preventDefault();

  const $loader = $('.jsc-loader-overlay');
  const $form = $(e.currentTarget);
  const serialNumber = $form.find('#serialNumber').val().trim();
  const $serialError = $form.find('.error-message.invalid-serial-no');
  const $warrantyFormContainer = $form.closest('.warranty-check-form');
  const $warrantyResult = $warrantyFormContainer.siblings('#warrantyResult');
  const failHtml = `
  <div class="warranty-fail_container">
    <div class="jsc-warranty-check-icon">${warrantyIcons.failed}</div>
    <p>Số serial không tìm thấy.</p>
    <p>Nếu bạn đã nhập đúng số serial, vui lòng liên hệ với <a href="mailto:vietnam@customercare.vorwerk.com">Bộ phận Chăm sóc Khách hàng</a> của chúng tôi.</p>
    <a href="/pages/warranty-check" class="warranty-check-btn link more"><span>Kiểm tra số serial khác &gt;</span></a>
  </div>
  `;

  const scrollToElement = ($el) => {
    $('html, body').animate({
      scrollTop: $el.offset().top - 100
    }, 300);
  };

  $loader.show();

  try {
    // --- Reset errors ---
    $serialError.hide();

    // --- Basic validation ---
    if (!serialNumber) {
      $serialError.show();
      return;
    }

    if (!serialNumber) {
      $serialError.show();
      return;
    }

    // --- CAPTCHA ---
    const captchaContainer = $form.find('[data-captcha-container]');
    const $captchaInput = $form.find('[data-captcha-input]');
    const $captchaValidBtn = $form.find('[data-captcha-validate]');
    const $captchaValid = $form.find('[data-captcha-valid]');

    if (captchaContainer.length) {
      if (!$captchaInput.val().trim()) {
        $captchaInput.addClass('error').focus();
        scrollToElement(captchaContainer);
        return;
      }

      $captchaValidBtn.trigger('click');

      if ($captchaValid.val() !== 'true') {
        scrollToElement(captchaContainer);
        return;
      }
    }

    // --- Fetch warranty data ---
    console.log('Checking warranty for:', { serialNumber });
    const warrantyPeriod = await fetchWarrantyPeriod(serialNumber);
    console.log('warrantyPeriod:', warrantyPeriod);

    if (warrantyPeriod?.status === 'success' && !warrantyPeriod?.warrantyInfo) {
        $warrantyFormContainer.hide();
        $warrantyResult.html(failHtml);
        return;
        // const result = await fetchAndDisplayWarrantyResult(failHtml);
        // if (result) {
        //     $warrantyResult.html(result);
        //     return;
        // } else {
        //     $warrantyResult.html(failHtml);
        //     return;
        // }
    }

    if (warrantyPeriod?.status === 'success' && warrantyPeriod?.warrantyInfo) {
        const { expiredDate, productDescription, warranty_activated } = warrantyPeriod.warrantyInfo;

        // --- Apply warranty checking rules ---
        // Primary condition: Check if warranty is activated
        if (!warranty_activated) {
            const pendingHtml = `
            <div class="warranty-result">
                <div class="warranty-pending">
                    <div class="jsc-warranty-check-icon">${warrantyIcons.checkmark}</div>
                    <p class="warranty-pending__message">
                        Bảo hành của bạn đã được gửi và đang chờ phê duyệt.
                    </p>
                    <p class="warranty-pending__message">
                        Bảo hành sẽ được kích hoạt sau khi được đội ngũ của chúng tôi xem xét.
                    </p>
                </div>
            </div>
            `;
            $warrantyFormContainer.hide();
            $warrantyResult.html(pendingHtml);
            return;
            // const result = await fetchAndDisplayWarrantyResult(pendingHtml);
            // if (result) {
            //     $warrantyResult.html(result);
            //     return;
            // } else {
            //     $warrantyResult.html(pendingHtml);
            //     return;
            // }
        }

        // Secondary condition: Check if warranty has expired
        if (expiredDate) {
            const today = new Date();
            const expiryDate = new Date(expiredDate);

            if (expiryDate < today) {
                // const expiredHtml = `
                //     <div class="warranty-result">
                //     <div class="warranty-expired">
                        
                //         <p class="warranty-expired__message">
                //         Thời hạn bảo hành đã hết. Nếu bạn cho rằng đây là lỗi hoặc muốn yêu cầu gia hạn, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi để được trợ giúp.
                //         </p>
                //     </div>
                //     </div>
                // `;
                let resultSerialNumber = '';
                let resultExpiryDate = '';

                if (serialNumber && serialNumber != '') {
                    resultSerialNumber = `<p class="product-serial-number">Số sê-ri: <strong>${serialNumber}</strong></p>`;
                }

                if (expiredDate && expiredDate != '') {
                    const formattedDate = new Intl.DateTimeFormat("en-GB", {
                        day: "numeric", month: "long", year: "numeric"
                    }).format(new Date(expiredDate));
        
                    resultExpiryDate = `<p class="product-expiry-date">Ngày hết hạn: <strong>${formattedDate}</strong></p>`;
                }

                const expiredHtml = `
                    <div class="warranty-result">
                        <div class="warranty-expired">
                            <div class="jsc-warranty-check-icon">${warrantyIcons.infoGrey}</div>
                            <div>${resultSerialNumber}${resultExpiryDate}</div>
                        </div>
                    </div>
                `;

                $warrantyFormContainer.hide();
                $warrantyResult.html(expiredHtml);
                return;
                // const result = await fetchAndDisplayWarrantyResult(expiredHtml);
                // if (result) {
                //     $warrantyResult.html(result);
                //     return;
                // } else {
                //     $warrantyResult.html(expiredHtml);
                //     return;
                // }
            }
        }

        // --- Build warranty result HTML for active warranty ---
        let warrantyResultHtml = '';

        // Create warranty result HTML based on data
        if (productDescription || serialNumber || expiredDate) {
            // warrantyResultHtml = `<div class="warranty-result_container">`;

            // if (productDescription && productDescription != '') {
            //     warrantyResultHtml += `<h4 class="product-description">Mô tả sản phẩm: ${productDescription}</h4>`;
            // }

            // if (serialNumber && serialNumber != '') {
            //     warrantyResultHtml += `<p class="product-serial-number">Số sê-ri: ${serialNumber}</p>`;
            // }

            // if (expiredDate && expiredDate != '') {
            // const formattedDate = new Intl.DateTimeFormat("en-GB", {
            //     day: "numeric", month: "long", year: "numeric"
            // }).format(new Date(expiredDate));

            // warrantyResultHtml += `<p class="product-expiry-date">Ngày hết hạn ${formattedDate}</p>`;
            // }

            // warrantyResultHtml += `</div>`;
            let resultSerialNumber = '';
                let resultExpiryDate = '';

                if (serialNumber && serialNumber != '') {
                    resultSerialNumber = `<p class="product-serial-number">Số sê-ri: <strong>${serialNumber}</strong></p>`;
                }

                if (expiredDate && expiredDate != '') {
                    const formattedDate = new Intl.DateTimeFormat("en-GB", {
                        day: "numeric", month: "long", year: "numeric"
                    }).format(new Date(expiredDate));
        
                    resultExpiryDate = `<p class="product-expiry-date">Ngày hết hạn: <strong>${formattedDate}</strong></p>`;
                }

                const expiredHtml = `
                    <div class="warranty-result">
                        <div class="warranty-valid">
                            <div class="jsc-warranty-check-icon">${warrantyIcons.infoGreen}</div>
                            <div>${resultSerialNumber}${resultExpiryDate}</div>
                        </div>
                    </div>
                `;

                $warrantyFormContainer.hide();
                $warrantyResult.html(expiredHtml);
                return;
        }

        // Fetch and display warranty result page with active warranty details
        $warrantyFormContainer.hide();
        $warrantyResult.html(warrantyResultHtml);
        return;
        // const result = await fetchAndDisplayWarrantyResult(warrantyResultHtml);
        // if (result) {
        //     $warrantyResult.html(result);
        //     return;
        // } else {
        //     $warrantyResult.html(warrantyResultHtml);
        //     return;
        // }
    } else {
        // If warranty fetch failed
        $warrantyFormContainer.hide();
        $warrantyResult.html(failHtml);
        return;
        // const result = await fetchAndDisplayWarrantyResult(failHtml);
        // if (result) {
        //     $warrantyResult.html(result);
        //     return;
        // } else {
        //     $warrantyResult.html(failHtml);
        //     return;
        // }
    }
  } catch (err) {
    console.error('Error in checkWarrantyPeriod:', err);
    $warrantyFormContainer.hide();
    $warrantyResult.html(failHtml);
    return;
    // const result = await fetchAndDisplayWarrantyResult(failHtml);
    // if (result) {
    //     $warrantyResult.html(result);
    //     return;
    // } else {
    //     $warrantyResult.html(failHtml);
    //     return;
    // }
  } finally {
    $loader.hide();
  }
};
// end: check warranty period
// start: check service warranty period
const checkServiceWarranty = async (e) => {
  const $form = $(e).closest('#serviceWarrantyForm');
  const $loader = $('.jsc-loader-overlay');
  const $serialError = $form.find('.error-message.invalid-serial-no');
  const $emailError = $form.find('.error-message.invalid-email');
  const $warrantyFail = $form.find('.warranty-fail');

  const scrollToElement = ($el) => {
      $('html, body').animate({
        scrollTop: $el.offset().top - 100
      }, 300);
  };

  $loader.show();

  try {
      const email = $form.find('#email').val().trim();
      const serialNumber = $form.find('#serialNumber').val().trim();

      // --- Reset errors ---
      $serialError.hide();
      $emailError.hide();
      $warrantyFail.hide();

      // --- Basic validation ---
      if (!email && !serialNumber) {
          $serialError.show();
          $emailError.show();
          return;
      }

      if (!serialNumber) {
          $serialError.show();
          return;
      }

      if (!email) {
          $emailError.show();
          return;
      }

      // --- Email format ---
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
          $emailError.show();
          return;
      }

      // --- CAPTCHA ---
      const captchaContainer = $form.find('[data-captcha-container]');
      const $captchaInput = $form.find('[data-captcha-input]');
      const $captchaValidBtn = $form.find('[data-captcha-validate]');
      const $captchaValid = $form.find('[data-captcha-valid]');

      if (captchaContainer.length) {
          if (!$captchaInput.val().trim()) {
              $captchaInput.addClass('error').focus();
              scrollToElement(captchaContainer);
              return;
          }

          $captchaValidBtn.trigger('click');

          if ($captchaValid.val() !== 'true') {
              scrollToElement(captchaContainer);
              return;
          }
      }

      // Fetch warranty info
      const result = await fetchWarrantyPeriod(serialNumber);
      console.log('serviceWarrantyPeriod:', result);

      if (!(result && result.status === 'success' && result.warrantyInfo?.expiredDate)) {
          $warrantyFail.show();
          return;
      }

      // Compare dates
      const today = new Date();
      const expiredDate = new Date(result.warrantyInfo.expiredDate);
      console.log('expiredDate:', expiredDate);

      const $productForm = $form.siblings('#service-product-form');
      const $action = $productForm.find('#service-product-form_action');
      console.log('productForm:', $productForm, 'action:', $action);
      const productWithin = $action.find('input[name="product_within_warranty"]').val() || '';
      const productOut = $action.find('input[name="product_out_of_warranty"]').val() || '';
      console.log('productWithin:', productWithin, 'productOut:', productOut);

      let variantId = '';
      if (expiredDate < today) variantId = productOut;
      else variantId = productWithin;
      console.log('variantId:', variantId);

      if (variantId) {
          $action.append(
              `<span class="btn" onclick="serviceProductATC('${serialNumber}', '${variantId}')">Add To Cart</span>`
          );
          $form.hide();
          $productForm.show();
      } else {
          $form.append(
              '<p class="error-message service-product-out-of-stock">Please contact our customer service <a href="mailto:malaysia_singapore@vorwerk.com">malaysia_singapore@vorwerk.com</a> for further assistance.</p>'
          );
      }
  } catch (err) {
      console.error(err);
      $form.append(
          '<p class="error-message service-product-out-of-stock">Please contact our customer service <a href="mailto:malaysia_singapore@vorwerk.com">malaysia_singapore@vorwerk.com</a> for further assistance.</p>'
      );
  } finally {
      $loader.hide();
  }
};
// helper to extract properties from form inputs
const getPropertiesFromForm = ($form) =>{
  const props = {};
  $form.find('[name^="properties["]').each(function () {
    const nameMatch = $(this).attr('name').match(/properties\[(.+?)\]/);
    if (nameMatch) {
      const key = nameMatch[1];
      const value = $(this).val();
      if (value) props[key] = value;
    }
  });
  return props;
}
const serviceProductATC = async (serialNumber, variantId) => {
  // console.log('serialNumber:', serialNumber, 'variantId:', variantId);

  const $loader = $('.jsc-loader-overlay');
  const $serviceProductForm = $('#service-product-form');
  const $defectPartStrInput = $('#defect-part-string-value');
  const $defectPartErrMessage = $('#defect-error-message');
  const $issueConcernStrInput = $('#issue-concern-string-value');
  const $issueConcernErrMessage = $('#issue-concern-error-message');

  $loader.show();

  // --- 1. Validate form ---
  const isValidForm = $serviceProductForm[0].checkValidity();
  const hasDefectPart = Boolean($defectPartStrInput.val());
  const hasIssueConcern = Boolean($issueConcernStrInput.val());

  if (!isValidForm || !hasDefectPart || !hasIssueConcern) {
    $defectPartErrMessage.toggle(!hasDefectPart);
    $issueConcernErrMessage.toggle(!hasIssueConcern);
    $serviceProductForm[0].reportValidity();
    console.warn('Service Product Form is invalid');
    $loader.hide();
    return;
  }

  // --- 2. Prepare form data ---
  const formData = new FormData($serviceProductForm[0]);

  // Ensure variant ID & serial number are included
  formData.set("id", variantId);
  formData.set("properties[Serial Number]", serialNumber);

  // Debug: show what’s inside formData
  // for (const [key, value] of formData.entries()) {
  //   console.log(key, ":", value);
  // }

  // --- 3. Send to Shopify cart ---
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    });

    const result = await response.json();
    // console.log("Cart add result:", result);

    if (!response.ok) {
      throw new Error(result.description || "Failed to add to cart");
    }

    // ✅ Success — you can redirect or update UI
    location.href = '/cart';
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert("Could not add service product. Please contact our customer service malaysia_singapore@vorwerk.com for further assistance.");
  } finally {
    $loader.hide();
  }
};
// end: check service warranty period

// start: warranty activation
const activateWarranty = async (e) => {
  e.preventDefault();

  const $form = $(e.currentTarget);
  const fullName = $form.find('#fullName').val().trim();
  const address = $form.find('#address').val().trim();
  const city = $form.find('#city').val().trim();
  const mobilePhone = $form.find('#mobilePhone').val().trim();
  const $mobilePhoneError = $form.find('.error-message.jsc-invalid-mobile-phone');
  const email = $form.find('#email').val().trim();
  const $emailError = $form.find('.error-message.jsc-invalid-email');
  const purchaseDate = $form.find('#purchaseDate').val().trim();
  const serialNumber = $form.find('#serialNumber').val().trim();
  const studioOwnerName = $form.find('#studioOwnerName').val().trim();
  const consent = $form.find('#consent').is(':checked');
  const $formSuccessMessage = $form.find('.warranty-activation-success');

  // form validation
  var hasError = false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\d+$/;
  
  if (!emailRegex.test(email)) {
    $emailError.removeClass('d-none');
    hasError = true;
  }
  else {
    $emailError.addClass('d-none');
  }
  if (!phoneRegex.test(mobilePhone)) {
    $mobilePhoneError.removeClass('d-none');
    hasError = true;
  }
  else {
    $mobilePhoneError.addClass('d-none');
  }

  if (!hasError) {
    let data = {
      full_name: fullName,
      address: address,
      city: city,
      mobile_phone: mobilePhone,
      email: email,
      purchase_date: purchaseDate,
      serial_number: serialNumber,
      studio_owner_name: studioOwnerName,
      consent: consent
    }

    $.ajax({
      url: "https://webhooks.mechanic.dev/29ca92e7-f4bf-4ae3-bb6b-296329177fb3", //user/warranty/activate
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: JSON.stringify(data),
      success: function() {
        console.log('Warranty activation successful', data);
        $formSuccessMessage.removeClass('hidden');
      }
    });
  }
}
// end: warranty activation

initCompanyPicturesFlickity = () => {
    
    if ($('.advisor-company-pictures__track').length > 0) {
        
        var $groupCell;
        var $countCell = $('.advisor-company-pictures').attr('data-slides-count');
        var $initSlider = false;
        var $autoplaySpeed = $('.advisor-company-pictures').attr('data-autoplay-speed');

        if ($(window).width() < 480) {
            $groupCell = 1;
            if ($countCell > 2) {
                $initSlider = true;
            }
        } else {
            $groupCell = 3;
            if ($countCell > 3) {
                $initSlider = true;
            }
        }

        // console.log('initCompanyPicturesFlickity');
        if ($initSlider) {
            var flkty = $('.advisor-company-pictures__track').flickity({
                freeScroll: true,
                wrapAround: true,
                adaptiveHeight: false,
                prevNextButtons: true,
                pageDots: false,
                resize: true,
                groupCells: $groupCell,
                cellAlign: 'left',
                contain: true,
                autoPlay: $autoplaySpeed
            });
        
            setTimeout(() => {
                flkty.resize();
            }, 100);
        }
        
    }
    
}

// start: password toggle visibility
const initPasswordToggle = () => {
  const toggleButtons = document.querySelectorAll('.password-toggle');

  for (const button of toggleButtons) {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const inputId = button.getAttribute('data-password-toggle');
      const passwordInput = document.getElementById(inputId);
      const eyeIcon = button.querySelector('.password-toggle__icon-eye');
      const eyeSlashIcon = button.querySelector('.password-toggle__icon-eye-slash');

      if (!passwordInput) return;

      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        eyeIcon.style.display = 'block';
        eyeSlashIcon.style.display = 'none';
        button.setAttribute('aria-label', 'Hide password');
      } else {
        passwordInput.type = 'password';
        eyeIcon.style.display = 'none';
        eyeSlashIcon.style.display = 'block';
        button.setAttribute('aria-label', 'Show password');
      }
    });
  }
};

const initHeliumFormPasswordToggle = () => {
  const passwordField = document.querySelector('.helium--register-password input[type="password"]');
  if (!passwordField) return;

  // ✅ Prevent duplicate wrapper
  if (passwordField.closest('.password-input-wrapper')) return;

  // ✅ Ensure password field has ID
  if (!passwordField.id) {
    passwordField.id = 'CustomerPassword';
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'password-input-wrapper';

  passwordField.parentNode.insertBefore(wrapper, passwordField);
  wrapper.appendChild(passwordField);

  // ✅ Inject toggle button with BOTH icons
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'password-toggle';
  toggle.setAttribute('data-password-toggle', passwordField.id);
  toggle.setAttribute('aria-label', 'Show password');

  toggle.innerHTML = `
    <svg class="icon icon-eye password-toggle__icon-eye" viewBox="0 0 64 64" width="20" height="20" style="display:none;">
      <path d="M32 12C18.75 12 7.5 19.5 1 32c6.5 12.5 17.75 20 31 20s24.5-7.5 31-20c-6.5-12.5-17.75-20-31-20zm0 36c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-26c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10z"/>
      <circle cx="32" cy="32" r="6"/>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-eye-slash password-toggle__icon-eye-slash" viewBox="0 0 64 64" width="20" height="20">
        <path d="M32 12C18.75 12 7.5 19.5 1 32c6.5 12.5 17.75 20 31 20s24.5-7.5 31-20c-6.5-12.5-17.75-20-31-20zm0 36c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-26c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10z" fill="currentColor" opacity="0.5"/>
        <circle cx="32" cy="32" r="6" fill="currentColor" opacity="0.5"/>
        <line x1="8" y1="8" x2="56" y2="56" stroke="currentColor" stroke-width="4" stroke-linecap="round" fill="none"/>
    </svg>
  `;

  wrapper.appendChild(toggle);

  // ✅ Activate toggle logic
  initPasswordToggle();
};
$(document).on('cf:ready', function() {
    initHeliumFormPasswordToggle();
});
// end: password toggle visibility